import React from "react";
import { Link } from "react-router-dom";
import SEOHelmet from "../components/SEOHelmet";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="not-found-page">
      <SEOHelmet
        title="Page not found | Panthi Events"
        description="The page you are looking for may have moved. Explore Panthi Events for wedding, corporate, and concert planning in Ahmedabad, Gujarat."
        noindex
      />
      <div className="not-found-inner">
        <p className="not-found-code">404</p>
        <h1 className="not-found-title">Page not found</h1>
        <p className="not-found-text">
          The link may be outdated. Use the navigation or jump to our most
          popular sections below.
        </p>
        <ul className="not-found-links">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/wedding-events">Wedding events</Link>
          </li>
          <li>
            <Link to="/corporate-events">Corporate events</Link>
          </li>
          <li>
            <Link to="/event-management-ahmedabad">Event management Ahmedabad</Link>
          </li>
          <li>
            <Link to="/blogs">Blogs</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NotFound;
